  import React, { useEffect, useState } from "react";
  import {
    Form, Button, Typography, Flex, Grid,
    InputNumber, Checkbox, Select, Switch
  } from "antd";
  import { App } from "antd";
  import InputField from "../../../components/Input/Input";
  import { useForm } from "antd/es/form/Form";
  import { useNavigate } from "react-router-dom";
  import { useDispatch, useSelector } from "react-redux";
  import {
    createOrUpdateAccount, fetchAccountsList, fetchAccountCode,
  } from "../accountsThunks";
  import { setSelectedAccount, setIsEditAccount } from "../accountsSlice";
  import { getAccountType, getGroupedAccountTypes } from "../../../lib/accountTypes";
  import InputNumberField from "../../../components/Input/InputNumber";
  import { getAccessType } from "../../../lib/functions";
  import axios from "axios"; // or however you make API calls
  import { fetchparentaccountsApi } from "../../../apiservice/accounts";

  const { Title } = Typography;
  const { useBreakpoint } = Grid;

  const CreateAccountForm = () => {
    const { modal } = App.useApp();
    const dispatch = useDispatch();
    const screens = useBreakpoint();
    const navigate = useNavigate();
    const [form] = useForm();
    const [access_type, access_type_set] = useState("");
    const [isSubAccount, setIsSubAccount] = useState(false);        // NEW
    const [parentAccounts, setParentAccounts] = useState([]);        // NEW
    const [loadingParents, setLoadingParents] = useState(false);     // NEW

    useEffect(() => {
      const access = getAccessType("account_entry");
      access_type_set(access);
    }, []);

    const { isEditAccount, selectedAccount, accountCode, accounts } = useSelector(
      (state) => state.accounts
    );

    // The duplicate-name check below needs the branch's accounts; they are only
    // loaded already when arriving from the account list.
    useEffect(() => {
      if (!accounts?.length) dispatch(fetchAccountsList());
    }, [dispatch]);

    // Mirrors the backend rule: names are unique per branch, ignoring case and
    // surrounding spaces. `accounts` already excludes customers/suppliers and
    // deleted accounts, which the rule does not cover.
    const validateUniqueAccountName = (_, value) => {
      const name = value?.trim().toLowerCase();
      if (!name) return Promise.resolve();
      const taken = (accounts || []).some(
        (acc) =>
          acc.acc_id !== selectedAccount?.acc_id &&
          acc.acc_name?.trim().toLowerCase() === name
      );
      return taken
        ? Promise.reject(new Error("An account with this name already exists. Please use a different account name."))
        : Promise.resolve();
    };

    const accountTypes = getAccountType();
    const acc_type_id = Form.useWatch("account_type", form);

    // NEW — fetch parent accounts when acc_type changes and isSubAccount is on
    useEffect(() => {
      if (acc_type_id && isSubAccount) {
        fetchParentAccounts(acc_type_id);
      } else {
        setParentAccounts([]);
        form.setFieldValue("parent_acc_id", undefined);
      }
    }, [acc_type_id, isSubAccount]);

    // NEW — also fetch when editing and account has a parent
    useEffect(() => {
      if (isEditAccount && selectedAccount) {
        const hasParent = !!selectedAccount.parent_acc_id;
        setIsSubAccount(hasParent);
        form.setFieldsValue({
          account_code: selectedAccount.acc_code || "",
          account_name: selectedAccount.acc_name || "",
          account_type: selectedAccount.acc_type_id || "",
          opening_balance: selectedAccount.opening_balance != null ? Number(selectedAccount.opening_balance) : null,
          bank_name: selectedAccount.bank_name || "",
          bank_account_number: selectedAccount.bank_acc_number || "",
          bank_account_type: selectedAccount.bank_acc_type || "",
          iban_number: selectedAccount.iban_no || "",
          ifsc_code: selectedAccount.ifsc_code || "",
          account_name_as_per_bank: selectedAccount.bank_acc_name_as_per_bank || "",
          bank_account_branch: selectedAccount.bank_branch || "",
          swift_code: selectedAccount.swift_code || "",
          is_primary_bank: !!selectedAccount.is_primary_bank_account,
          parent_acc_id: selectedAccount.parent_acc_id || undefined,
        });
        // load parent list for edit
        if (hasParent && selectedAccount.acc_type_id) {
          fetchParentAccounts(selectedAccount.acc_type_id);
        }
      } else {
        form.resetFields();
        setIsSubAccount(false);
        form.setFieldsValue({ opening_balance: 0 });
      }
    }, [isEditAccount, selectedAccount]);

    const fetchParentAccounts = async (acc_type_id) => {
      setLoadingParents(true);
      try {
        // Replace with your actual API call method
        const res = await fetchparentaccountsApi(
    { acc_type_id }
        );
        console.log('resssssssss::::',res)
        setParentAccounts(
          (res.data.data || []).map((a) => ({
            label: a.acc_name,
            value: a.acc_id,
          }))
        );
      } catch (e) {
        setParentAccounts([]);
      } finally {
        setLoadingParents(false);
      }
    };

    const groupedAccountTypes = getGroupedAccountTypes();

    // Retained Earnings is a system-managed account: only reachable via editing the
    // existing row (never selectable when creating a brand-new account), and only its
    // opening balance may be changed. Opening balance reconciliation happens via the
    // bulk Opening Balances screen, not a per-account offset requirement.
    const isSystemAccount = isEditAccount && !!selectedAccount?.is_system_account;

    const filteredGroupedAccountTypes = groupedAccountTypes.map((group) => ({
      ...group,
      options: group.options.filter(
        (opt) => opt.acc_type_id !== "retained_earnings" || isSystemAccount
      ),
    }));

const hideOpeningBalance = [
  "sale_account",
  "sale_return", 
  "purchase_account",
  "purchase_return",
  "service_expense_account",
  "service_account",
  "service_return",
].includes(acc_type_id);
    useEffect(() => {
      dispatch(fetchAccountCode());
    }, [dispatch]);

    useEffect(() => {
      if (!isEditAccount && accountCode) {
        form.setFieldsValue({ account_code: accountCode });
      }
    }, [accountCode, isEditAccount, form]);

    const handleCancel = () => {
      dispatch(setSelectedAccount(null));
      dispatch(setIsEditAccount(false));
      navigate(-1);
    };

    const submitAccount = async (values) => {
      try {
        const selectedType = accountTypes.find(
          (t) => t.acc_type_id === values.account_type
        );
        const result = await dispatch(
          createOrUpdateAccount({
            acc_code: isEditAccount ? selectedAccount?.acc_code : accountCode,
            acc_name: values.account_name?.trim(),
            acc_type: selectedType,
            opening_balance: values.opening_balance || 0,
            institution_name: values.institution_name || "",
            address: values.address || "",
            country_code: values.country_code || "",
            contact_no: values.contact_no || "",
            party_type: values.party_type || "no",
            location_id: values.selectedLocation?.location_id || 0,
            group_id: values.selectedGroup?.group_id || 0,
            credit_limit: values.credit_limit || 0,
            email_address: values.email_address || "",
            bank_acc_number: values.bank_account_number || "",
            swift_code: values.swift_code || "",
            ifsc_code: values.ifsc_code || "",
            iban_no: values.iban_number || "",
            bank_acc_name: values.bank_acc_name || "",
            bank_acc_name_as_per_bank: values.account_name_as_per_bank || "",
            bank_name: values.bank_name || "",
            bank_branch: values.bank_account_branch || "",
            bank_acc_type: values.bank_account_type || "",
            is_primary_bank_account: values.is_primary_bank || false,
            // NEW fields
            parent_acc_id: isSubAccount ? (values.parent_acc_id || null) : null,
            action: isEditAccount ? "update" : "create",
            acc_id: selectedAccount?.acc_id || 0,
          })
        ).unwrap();

        // The backend returns HTTP 200 with { error: true, msg } for rejected saves
        // (e.g. the system-managed / mandatory-offset checks above) — axios/unwrap()
        // don't treat that as a failure on their own, so it must be checked explicitly
        // or a rejected save would silently show as "successful" with nothing changed.
        if (result?.error) {
          modal.warning({ title: result.msg || "Save failed" });
          return;
        }

        modal.success({
          title: isEditAccount ? "Account updated successfully" : "Account created successfully",
        });
        dispatch(setSelectedAccount(null));
        dispatch(setIsEditAccount(false));
        navigate("/accounts/account-entry");
        dispatch(fetchAccountsList());
      } catch (error) {
        modal.warning({ title: error.message || "Save failed" });
      }
    };

    const handleSave = async (values) => {
      await submitAccount(values);
    };

    return (
      <div className="account-form">
        <Title level={2} style={{ marginBottom: "32px" }}>
          {isEditAccount ? "Update Account" : "Create New Account"}
        </Title>

        <Form
          form={form}
          layout="vertical"
          requiredMark={(label, { required }) =>
            required ? <>{label} <span style={{ color: "#ff4d4f" }}>*</span></> : label
          }
          onFinish={handleSave}
          autoComplete="off"
          variant="filled"
          style={{ maxWidth: "1400px" }}
          className="responsive-form"
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 18 }}
          initialValues={{ account_code: accountCode }}
        >
          <Flex
            gap={!screens.md || !screens.xl ? 10 : 80}
            justify="center"
            style={{
              flexDirection: !screens.md || !screens.xl ? "column" : "row",
              width: "100%",
              marginBottom: "24px",
            }}
          >
            {/* LEFT COLUMN */}
            <Flex vertical gap={10} style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}>
              <Form.Item label="Account Code" name="account_code" rules={[{ required: true }]}>
                <InputField placeholder="Enter Account Code" disabled />
              </Form.Item>

              <Form.Item label="Account Type" name="account_type" rules={[{ required: true }]}>
                <Select
                  showSearch
                  placeholder="Select Account Type"
                  options={filteredGroupedAccountTypes}
                  optionFilterProp="label"
                  disabled={isSystemAccount}
                />
              </Form.Item>

<Form.Item>
  <Checkbox
    checked={isSubAccount}
    disabled={isSystemAccount}
    onChange={(e) => {
      setIsSubAccount(e.target.checked);
      if (!e.target.checked) form.setFieldValue("parent_acc_id", undefined);
    }}
  >
    Make this a sub-account
  </Checkbox>
</Form.Item>

              {/* NEW — Parent account dropdown (only shows when isSubAccount = true) */}
              {isSubAccount && (
                <Form.Item
                  label="Under Account"
                  name="parent_acc_id"
                  rules={[{ required: true, message: "Please select a parent account" }]}
                >
                  <Select
                    showSearch
                    placeholder="Select parent account"
                    options={parentAccounts}
                    loading={loadingParents}
                    optionFilterProp="label"
                    notFoundContent={
                      loadingParents
                        ? "Loading..."
                        : acc_type_id
                        ? "No group accounts found for this type. Create a group account first."
                        : "Select account type first"
                    }
                  />
                </Form.Item>
              )}

              {acc_type_id === "bank_account" && (
                <>
                  <Form.Item label="Bank Name" name="bank_name">
                    <InputField placeholder="Bank Name" />
                  </Form.Item>
                  <Form.Item label="Bank Account Number" name="bank_account_number">
                    <InputNumberField precision={0} placeholder="Bank Account Number" />
                  </Form.Item>
                  <Form.Item label="Bank Account Type" name="bank_account_type">
                    <InputField placeholder="Bank Account Type" />
                  </Form.Item>
                  <Form.Item label="IBAN Number" name="iban_number">
                    <InputField placeholder="IBAN Number" />
                  </Form.Item>
                </>
              )}
            </Flex>

            {/* RIGHT COLUMN */}
            <Flex vertical gap={10} style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}>
              <Form.Item
                label="Account Name"
                name="account_name"
                rules={[{ required: true }, { validator: validateUniqueAccountName }]}
              >
                <InputField placeholder="Enter Account Name" disabled={isSystemAccount} />
              </Form.Item>

             {!hideOpeningBalance && (
          <Form.Item label="Opening Balance" name="opening_balance">
            <InputNumber
              step={1}
              precision={2}
              style={{ width: "100%" }}
              onClick={() => {
                const val = form.getFieldValue("opening_balance");

                if (val !== null && val !== undefined) {
                  form.setFieldValue("opening_balance", null);
                }
              }}
              onWheel={(e) => e.target.blur()}
            />
          </Form.Item>
        )}

              {acc_type_id === "bank_account" && (
                <>
                  <Form.Item
                    label="Account Name As Per Bank"
                    name="account_name_as_per_bank"
                    rules={[{ required: true, message: "Account Name As Per Bank is required" }]}
                  >
                    <InputField placeholder="Account Name As Per Bank" />
                  </Form.Item>
                  <Form.Item label="Bank Account Branch" name="bank_account_branch">
                    <InputField placeholder="Bank Account Branch" />
                  </Form.Item>
                  <Form.Item label="Swift Code" name="swift_code">
                    <InputField placeholder="Swift Code" />
                  </Form.Item>
                  <Form.Item label="IFSC Code" name="ifsc_code">
                    <InputField placeholder="IFSC Code" />
                  </Form.Item>
                  <Form.Item name="is_primary_bank" valuePropName="checked">
                    <Checkbox>Use this as the primary bank account</Checkbox>
                  </Form.Item>
                </>
              )}
            </Flex>
          </Flex>

          <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
            <Button size="large" shape="default" onClick={handleCancel} className="traic-button">
              Back
            </Button>
            {access_type === "WRITE" && (
              <Button type="primary" size="large" htmlType="submit" className="traic-button">
                {isEditAccount ? "Update" : "Save"}
              </Button>
            )}
          </Flex>
        </Form>
      </div>
    );
  };

  export default CreateAccountForm;